import React, { useState } from "react";
import { useFormik } from "formik";
import { connect, useDispatch } from "react-redux";
import { Link, Redirect, useHistory } from "react-router-dom";
import * as Yup from "yup";
import { forgetPasswordLevel1 } from "../../../redux/login/forgetPass";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTryUpdate,
} from "../../../common/method/handleNotificationAlert";
import { actionTypes as actionTypesNotif } from "./../../../redux/notificationAlert";
import { makeStyles } from "@mui/styles";
import { convertDigitToEnglish } from "../../../common/method/convertDigitToEnglish";
import { useTheme } from "@mui/material/styles";

const useStyles = makeStyles((theme) => ({
  input: {
    backgroundColor: "white !important",
    width: "100%",
    border: "none",
    margin: "15px auto",
    boxShadow: "0 3px 6px rgba(0,0,0,0.16)",
    borderRadius: 5,
  },
  returnBtn: {
    color: "black",
    "&:hover": {
      color: "black",
      fontWeight: 900,
      borderBottom: "1px solid black",
    },
  },
}));

const initialValues = {
  email: "",
};

function ForgotPassword(props) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { push } = useHistory();
  const classes = useStyles();
  const { intl } = props;
  const [isRequested, setIsRequested] = useState(false);
  const theme = useTheme();
  const ForgotPasswordSchema = Yup.object().shape({
    email: Yup.string()
      // .email("Wrong email format")
      .min(10, "کد ملی/شناسه ملی حداقل باید 10 رقم و به صورت عدد باشد")
      .max(11, "کد ملی/شناسه ملی حداکثر باید 11 رقم و به صورت عدد باشد")
      .required(
        // intl.formatMessage({
        //   id: "AUTH.VALIDATION.REQUIRED_FIELD",
        // })
        "وارد کردن کد ملی الزامی میباشد",
      ),
  });

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const formik = useFormik({
    initialValues,
    validationSchema: ForgotPasswordSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setLoading(true);
      let data = {
        national_id: convertDigitToEnglish(values.email),
        needs_sms: "TRUE",
      };
      forgetPasswordLevel1(data)
        .then((res) => {
          let isok = handleNotificationAlertTryUpdate(res);
          if (!isok) {
            return;
          }
          setSubmitting(false);
          dispatch({
            type: actionTypesNotif.success,
            textAlert:
              "لینک بازیابی رمز عبور برای شما ارسال شد . از طریق لینک میتوانید اقدام به تعویض رمز عبور خود کنید",
          });

          setTimeout(() => {
            props.setflagLogin(4);
          }, 2000);
        })

        .catch(() => {
          setSubmitting(false);
          setLoading(false);
          handleNotificationAlertCatch();
        })
        .finally(() => {
          setSubmitting(false);
          setLoading(false);
        });
    },
  });

  return (
    <>
      {isRequested && <Redirect to="/auth" />}
      {!isRequested && (
        <div className="login-form login-forgot" style={{ display: "block" }}>
          <div className="text-sm  mt-3 mb-3 font-medium">
            لینک بازیابی رمز عبور به ایمیل شما ارسال می شود
          </div>
          <form
            onSubmit={formik.handleSubmit}
            className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
          >
            {formik.status && (
              <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
                <div className="alert-text font-weight-bold">
                  {formik.status}
                </div>
              </div>
            )}
            <div className="fv-plugins-icon-container pt-3">
              <input
                placeholder="کد ملی / شناسه ملی"
                type="text"
                className={`w-full border h-12 py-4 px-5 focus:border-gray-400 outline-none rounded-md ${getInputClasses(
                  "email",
                )} authInput`}
                name="email"
                {...formik.getFieldProps("email")}
                onChange={(event) => {
                  formik.setFieldValue(
                    "email",
                    event.target.value.replace(/\s/g, ""),
                  );
                }}
              />
              <div className={`errorPlace`}>
                {formik.touched.email && formik.errors.email ? (
                  <div className="fv-plugins-message-container flex mt-1 ">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="red"
                      class="bi bi-exclamation-triangle-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                    </svg>
                    <div className="fv-help-block d-inline-block mr-1 text-xs text-red-400">
                      {formik.errors.email}
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
            <div className="flex flex-col">
              <button
                id="kt_forget_pass_submit"
                type="submit"
                disabled={formik.isSubmitting}
                className="w-full  text-white rounded-lg h-10 mt-7 text-sm  flex justify-center items-center"
                style={
                  formik.values.email.length >= 10 &&
                  formik.values.email.length < 12
                    ? {
                        backgroundColor: theme.palette.primary.main,
                        color: "white",
                      }
                    : { backgroundColor: "#F8F8F8", color: "#C9C9C9" }
                }
              >
                <span>ارسال لینک بازیابی رمز عبور</span>
                {loading && (
                  <span className="ml-3 spinner spinner-white"></span>
                )}
              </button>
              <div
                className={`mt-5 mb-10 text-black cursor-pointer w-full flex justify-center`}
                onClick={() => props.setflagLogin(1)}
              >
                {/* <Link role={'button'} to="/auth/login" className={`${classes.returnBtn}`}>بازگشت</Link> */}
                بازگشت
              </div>
            </div>
          </form>
        </div>
      )}
    </>
  );
}

export default ForgotPassword;
